module.exports = __webpack_public_path__ + "static/media/rsAnimeOP4.63559a04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/press/rsAnimeOP4.jpg
// module id = 569
// module chunks = 0